import { ReactNode } from "react";
import Modal from "components/DesignSystem/Modal/Modal";
import { Button } from "components/DesignSystem/Button/Button";
import { FilledTriangleWarning } from "components/icons/FilledTriangleWarning";

type PayFilingConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: ReactNode;
  secondaryLabel: string;
  primaryLabel: string;
  onSecondary: () => void;
  onPrimary: () => void;
  isPrimaryLoading?: boolean;
  isSecondaryLoading?: boolean;
};

export const PayFilingConfirmModal = ({
  open,
  onClose,
  title,
  description,
  secondaryLabel,
  primaryLabel,
  onSecondary,
  onPrimary,
  isPrimaryLoading = false,
  isSecondaryLoading = false,
}: PayFilingConfirmModalProps) => {
  const isBusy = isPrimaryLoading || isSecondaryLoading;

  const handleOpenChange = (nextOpen: boolean): void => {
    if (isBusy) return;
    if (!nextOpen) onClose();
  };

  return (
    <Modal.Root open={open} onOpenChange={handleOpenChange}>
      <Modal.Content size="small">
        <Modal.Body className="t-flex t-flex-col t-gap-4">
          <div className="t-flex t-items-start t-justify-between">
            <span className="t-flex t-h-10 t-w-10 t-items-center t-justify-center t-rounded-full t-bg-orange-10 t-text-orange">
              <FilledTriangleWarning />
            </span>

            <Modal.Close disabled={isBusy} />
          </div>

          <div className="t-flex t-flex-col t-gap-2">
            <p className="t-m-0 t-text-subtitle-lg t-text-text-100">{title}</p>
            <div className="t-text-body t-text-text-30">{description}</div>
          </div>
        </Modal.Body>

        <Modal.FooterButtonGroup>
          <Button
            type="button"
            customType="secondary"
            onClick={onSecondary}
            isLoading={isSecondaryLoading}
            disabled={isPrimaryLoading}
          >
            {secondaryLabel}
          </Button>
          <Button
            type="button"
            customType="primary"
            onClick={onPrimary}
            isLoading={isPrimaryLoading}
            disabled={isSecondaryLoading}
          >
            {primaryLabel}
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
